module.exports = __webpack_public_path__ + "img/sdg10_jp.6ec23713.png";